const Slugify = {
  methods: {
    slugify(text) {
      const REGEX_JAPANESE =
        /[\u3000-\u303f]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\uff00-\uff9f]|[\u4e00-\u9faf]|[\u3400-\u4dbf]/
      const REGEX_CHINESE =
        /[\u4e00-\u9fff]|[\u3400-\u4dbf]|[\u{20000}-\u{2a6df}]|[\u{2a700}-\u{2b73f}]|[\u{2b740}-\u{2b81f}]|[\u{2b820}-\u{2ceaf}]|[\uf900-\ufaff]|[\u3300-\u33ff]|[\ufe30-\ufe4f]|[\uf900-\ufaff]|[\u{2f800}-\u{2fa1f}]/u
      const REGEX_ARABIC = /[\u0600-\u06FF]/

      const hasJapanese = REGEX_JAPANESE.test(text)
      const hasChinese = REGEX_CHINESE.test(text)
      const hasArabic = REGEX_ARABIC.test(text)

      if (hasJapanese || hasChinese || hasArabic) {
        return text.toString().toLowerCase().replace(/ /g, '-')
      }

      return text
        .toString()
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '')
    },
    randomify() {
      return Math.random().toString(36).slice(2)
    },
  },
}

export default Slugify
